import React from "react";
import { ID } from "common/entities/IEntity";
import * as glossaryFragments from "./article/glossaryFragments";
import { FragmentLayout } from "../../core/components/FragmentLayout";
import * as commonFragments from "./article/commonFragments";

interface IGlossaryTermListProps {
	article: ID;
	config: any;
}

export default function ArticleGlossary(props: IGlossaryTermListProps) {
	return (
		<React.Fragment>
			<FragmentLayout
				layout={props.config.glossaryLayout}
				fragments={{ ...glossaryFragments, ...commonFragments }}
				props={{
					article: props.article,
				}}
			/>
		</React.Fragment>
	);
}



// WEBPACK FOOTER //
// ./src/panels/articleDetails/ArticleGlossary.tsx